// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"41dc8c49","145":"a03796c6","148":"7a0579c4","303":"27a8226f","338":"674fc4ef","675":"46c37f57"}[chunkId] + ".chunk.js";
};